import { render, staticRenderFns } from "./createReformCatalog.vue?vue&type=template&id=394512a7&scoped=true"
import script from "./createReformCatalog.vue?vue&type=script&lang=js"
export * from "./createReformCatalog.vue?vue&type=script&lang=js"
import style0 from "./createReformCatalog.vue?vue&type=style&index=0&id=394512a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394512a7",
  null
  
)

export default component.exports